import { MethodHandler, MethodProperties } from '@lentau/analytics/health-metrics/shared';

import { INTERVAL_HANDLER_LIST, INTERVAL_PROPERTIES_LIST } from './intervals/intervals-method-list';
import { CART_HANDLER_LIST, CART_PROPERTIES_LIST } from './cart/cart-method-list';
import { ORDER_EDIT_HANDLER_LIST, ORDER_EDIT_PROPERTIES_LIST } from './order-edit/order-edit-method-list';
import { CATEGORY_HANDLER_LIST, CATEGORY_PROPERTIES_LIST } from './categories/categories-method-list';
import { CHECKOUT_HANDLER_LIST, CHECKOUT_PROPERTIES_LIST } from './checkout/checkout-method-list';
import { PRODUCT_HANDLER_LIST, PRODUCT_PROPERTIES_LIST } from './product/product-method-list';
import { PAYMENT_HANDLER_LIST, PAYMENT_PROPERTIES_LIST } from './payment/payment-method-list';
import { AUTH_HANDLER_LIST, AUTH_PROPERTIES_LIST } from './auth/auth-method-list';
import {
  PURCHASED_PRODUCT_HANDLER_LIST,
  PURCHASED_PRODUCT_PROPERTIES_LIST,
} from './purchased-products/purchased-products-handler';
import { ACTION_DETAIL_HANDLER_LIST, ACTION_DETAIL_PROPERTIES_LIST } from './action-detail/action-detail-method-list';
import { NPS_HANDLER_LIST, NPS_PROPERTIES_LIST } from './nps/nps-method-list';
import { COMMON_METHOD_PROPERTIES_LIST } from '../handlers/other-methods';

export const METHOD_HANDLER_LIST: MethodHandler = {
  ...ORDER_EDIT_HANDLER_LIST,
  ...CART_HANDLER_LIST,
  ...INTERVAL_HANDLER_LIST,
  ...CATEGORY_HANDLER_LIST,
  ...CHECKOUT_HANDLER_LIST,
  ...PRODUCT_HANDLER_LIST,
  ...PAYMENT_HANDLER_LIST,
  ...AUTH_HANDLER_LIST,
  ...PURCHASED_PRODUCT_HANDLER_LIST,
  ...ACTION_DETAIL_HANDLER_LIST,
  ...NPS_HANDLER_LIST,
};

export const METHOD_PROPERTIES_LIST: MethodProperties[] = [
  COMMON_METHOD_PROPERTIES_LIST,
  ORDER_EDIT_PROPERTIES_LIST,
  CART_PROPERTIES_LIST,
  INTERVAL_PROPERTIES_LIST,
  CATEGORY_PROPERTIES_LIST,
  CHECKOUT_PROPERTIES_LIST,
  PRODUCT_PROPERTIES_LIST,
  PAYMENT_PROPERTIES_LIST,
  AUTH_PROPERTIES_LIST,
  PURCHASED_PRODUCT_PROPERTIES_LIST,
  ACTION_DETAIL_PROPERTIES_LIST,
  NPS_PROPERTIES_LIST,
];
